const capabilities = ['HARDWARE', 'NETWORKING', 'COMPUTING', 'PRINTING', 'MAINTENANCE', 'SUPPORT'];

export default function CapabilityStrip() {
  return (
    <section className="py-16 md:py-20 bg-background-50 relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 dot-pattern opacity-20"></div>

      <div className="max-w-site mx-auto px-4 md:px-6 relative z-10">
        <h2 className="text-center font-heading text-[28px] md:text-[36px] font-bold text-foreground-950 tracking-[-0.02em] mb-10 md:mb-12 animate-on-scroll">
          Everything your business needs.<br className="md:hidden" /> Nothing it doesn&apos;t.
        </h2>

        <div className="flex flex-wrap justify-center items-center gap-x-6 md:gap-x-10 gap-y-3 animate-on-scroll">
          {capabilities.map((cap, i) => (
            <div key={cap} className="flex items-center gap-x-6 md:gap-x-10">
              {i > 0 && (
                <span className="hidden sm:block w-px h-4 bg-background-300"></span>
              )}
              <span className="font-heading text-sm md:text-base font-bold text-foreground-800 tracking-[0.06em] hover:text-primary-500 transition-colors duration-300 cursor-default">
                {cap}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}